import React from "react";
import { Chip, Box } from "@mui/material";

/**
 * Badge visual para identificar ambiente não-produção
 * Aparece apenas em desenvolvimento e sandbox
 */
const EnvironmentBadge = () => {
  const currentEnvironment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
  const isSandbox = process.env.REACT_APP_ENVIRONMENT === "sandbox";
  const isProduction = process.env.NODE_ENV === "production" && !process.env.REACT_APP_ENVIRONMENT;

  // Não mostrar em produção
  if (isProduction) {
    return null;
  }

  // Configuração do badge baseada no ambiente
  const getBadgeConfig = () => {
    // if (isDevelopment) {
    //   return {
    //     text: "🔧 DEV",
    //     color: "#2196F3", // Blue
    //   };
    // }
    if (isSandbox) {
      return {
        text: "🧪 SANDBOX",
        color: "#FF9800", // Orange
      };
    }

    return null;
  };

  const badgeConfig = getBadgeConfig();

  if (!badgeConfig) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 8,
        right: 8,
        zIndex: 9999,
        opacity: 0.9,
        transition: "opacity 0.3s",
        "&:hover": {
          opacity: 1,
        },
      }}
    >
      <Chip
        label={badgeConfig.text}
        size="small"
        sx={{
          backgroundColor: badgeConfig.color,
          color: "white",
          fontWeight: "bold",
          fontSize: "10px",
          height: "20px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          "& .MuiChip-label": {
            padding: "0 6px",
          },
        }}
        onClick={() => {
          // Click para mostrar detalhes do ambiente
          console.group("🔧 Environment Details");
          console.log("Current Environment:", currentEnvironment);
          console.log("NODE_ENV:", process.env.NODE_ENV);
          console.log("REACT_APP_ENVIRONMENT:", process.env.REACT_APP_ENVIRONMENT);
          console.log("REACT_APP_BASE_URL:", process.env.REACT_APP_BASE_URL);
          console.log("Current URL:", window.location.href);
          console.log("Build Time:", new Date().toISOString());
          console.groupEnd();
        }}
      />
    </Box>
  );
};

export default EnvironmentBadge;
